import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Docs.css';
import PoliciesTocMain from './PoliciesTocMain';
import PoliciesTocMinor from './PoliciesTocMinor';
import Privacy from './Privacy';
import Terms from './Terms';
import { useParams } from "react-router-dom";

export default function Policies(props) {
  const { reason } = useParams();
  return <PoliciesForReason {...props} reason={reason} />;
}

export class PoliciesForReason extends Component {
  constructor(props) {
    super(props);
    this.state = { policyInFocus: ( props.policyInFocus ? props.policyInFocus : props.reason ) };
    this.setPolicyInFocus = this.setPolicyInFocus.bind(this);
  }

  setPolicyInFocus(policy, e)  {
    e.preventDefault();
    this.setState({ policyInFocus: policy});
  }

  render() {
    let renderContent;
    if (this.state.policyInFocus === 'terms') {
      renderContent = <Terms className="docs-content" setPolicyInFocus={this.setPolicyInFocus}/>;
    } else {
      renderContent = <Privacy className="docs-content" setPolicyInFocus={this.setPolicyInFocus}/>;
    }

    return (
      <div>
        <Container fluid>
          <Row>
            <Col xs={2} className="docs-toc-main"><PoliciesTocMain setPolicyInFocus={this.setPolicyInFocus} policyInFocus={this.state.policyInFocus}/></Col>
            <Col xs={7} className="docs-contenct">
              {renderContent}
            </Col>
            <Col xs={3} className="docs-toc-minor"><PoliciesTocMinor policyInFocus={this.state.policyInFocus}/></Col>
          </Row>
        </Container>
      </div>
    );
  }
}